var publish = {};

var AC = 'Air Conditioning';
var BASEMENT = 'Basement';
var BATHROOM = 'Bathroom';
var GARAGE = 'Garage';
var FURNACE = 'Furnace';
var KITCHEN = 'Kitchen';
var LAUNDRY = 'Laundry';
var LIVING = 'Living Room';
var MASTER = 'Master Bedroom';
var OFFICE = 'Office';
var OTHER_EV_CHARGING = 'Non-Tesla EV Charging';
var TESLA_EV_CHARGING = 'Tesla EV Charging';
var WELL_PUMP = 'Well Pump';
var WIFI = 'WiFi';
var order = 1;
var appliances$1 = new Map();

var addAppliance = function addAppliance(appliance, batteryMinimum) {
  appliances$1.set(appliance, {
    name: appliance,
    batteryMinimum: batteryMinimum,
    order: order++
  });
}; // Note that these should be added in the order they need to appear in the front end


addAppliance(KITCHEN, 1);
addAppliance(MASTER, 1);
addAppliance(GARAGE, 1);
addAppliance(BATHROOM, 1);
addAppliance(WIFI, 1);
addAppliance(LIVING, 1);
addAppliance(FURNACE, 1);
addAppliance(BASEMENT, 1);
addAppliance(AC, 2);
addAppliance(TESLA_EV_CHARGING, 2);
addAppliance(OFFICE, 1);
addAppliance(LAUNDRY, 1);
addAppliance(WELL_PUMP, 3);
addAppliance(OTHER_EV_CHARGING, 3);
var appliances_1$1 = {
  appliances: appliances$1
};

var TESLA$1 = 'Tesla Powerwall 2';
var batteryModels$1 = new Map();
batteryModels$1.set(TESLA$1, {
  image: {
    // TODO: replace with approved image assets
    quantity1: 'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9hY2NvdW50c1wvZThcLzQwMDAzNTdcL3Byb2plY3RzXC8xM1wvYXNzZXRzXC84MVwvMTExNDBcLzhmMzJjMjdmMjhlOTJkZTI4YzQ0MTRmNDAwYzczMWMxLTE1ODY5NzE5NDYuanBnIn0:sunrun:DjCa3C5f9kLjQdkkU6Ju97O7VAHd_797Kyr0MAx4XZE?width=600',
    quantity2: 'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9hY2NvdW50c1wvZThcLzQwMDAzNTdcL3Byb2plY3RzXC8xM1wvYXNzZXRzXC84MVwvMTExNDBcLzhmMzJjMjdmMjhlOTJkZTI4YzQ0MTRmNDAwYzczMWMxLTE1ODY5NzE5NDYuanBnIn0:sunrun:DjCa3C5f9kLjQdkkU6Ju97O7VAHd_797Kyr0MAx4XZE?width=600',
    quantity3: 'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9hY2NvdW50c1wvZThcLzQwMDAzNTdcL3Byb2plY3RzXC8xM1wvYXNzZXRzXC84MVwvMTExNDBcLzhmMzJjMjdmMjhlOTJkZTI4YzQ0MTRmNDAwYzczMWMxLTE1ODY5NzE5NDYuanBnIn0:sunrun:DjCa3C5f9kLjQdkkU6Ju97O7VAHd_797Kyr0MAx4XZE?width=600'
  },
  kW: 7.6,
  manufacturer: 'Tesla',
  model: 'Powerwall 2 AC',
  uiDisplayName: 'Tesla Powerwall',
  name: TESLA$1
});
var batteryModels_1$1 = {
  batteryModels: batteryModels$1,
  TESLA: TESLA$1
};

var _require = appliances_1$1,
    appliances = _require.appliances;

var _require2 = batteryModels_1$1,
    batteryModels = _require2.batteryModels,
    TESLA = _require2.TESLA;

var appliances_1 = publish.appliances = appliances;
var batteryModels_1 = publish.batteryModels = batteryModels;
var constants = publish.constants = {
  TESLA: TESLA
};

export default publish;
export { appliances_1 as appliances, batteryModels_1 as batteryModels, constants };
